import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  MAX_NDC_ALLOWED,
  NDC_LIMIT_TO_1000,
  REBATE_SELECT,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getRebateProgrameList,
  getPlanTypeValues,
  getndcdetailsgrid,
  setSearchInput,
  dispatchErrorMsgNDCDetail,
  getLabelerList,
  setNDCDetailReportData,
  dispatchSelectType
} from '../Store/actions';

import { viewClaimDetailButton } from './ConstantData';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

export default function ReqNDCDetails(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    rebateProgramList: rebateProgramListData,
    rebateProgram: rebateProgramValue,
    plan,
    errors,
    errorMsgPerDisRes: getErrorMsg,
    selectedSearchType,
    searchResult,
    selectedNDC,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
  } = useSelector((state) => state?.sharedState?.NDCDetailsReducer);

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.NDCDetailsReducer?.performDisputeResolutionObj
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [errorList, setErrorList] = React.useState(errors);
  const [openModal, setOpenModal] = React.useState(false);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [radioList, setRadioList] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState([]);
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  const [searchTypeRadioList] = React.useState([
    { name: 'NDC', value: 'NDC' },
    { name: 'Name', value: 'Name' },
    { name: 'Labeler', value: 'Labeler' },
  ]);
  let intialState = selectedSearchType?selectedSearchType:userDefaults?.defNdcSelectModeCd?
  userDefaults?.defNdcSelectModeCd:"NDC";
  if (intialState === "NAME") {
    intialState = "Name";
  } else if (intialState === "LABELER") {
    intialState = "Labeler";
  } 
  const [searchType, setSearchType] = React.useState(intialState);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [planType, setPlanType] = React.useState(plan);
  const [selectList, setSelectList] = React.useState([]);

  useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  React.useEffect(() => {
    if(searchType){
    dispatch(dispatchSelectType(searchType));
    }
  }, [searchType]);
  // variable deceleration for search type component
  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = React.useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          shortDesc: obj.shortDescription,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(plan || tempPlanType?.value);
    }
  }, [planTypeList]);

  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));

    // if (list.length) {
    setSelectList(list);

    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );

    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  // If any error in errorlist it highlights the tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/ndcdetails', true);
    } else {
      tabHighLigther('/ndcdetails', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // Function to get the labeler code data in case of NDC and name selected
  const getLabelerData = async () => {
    const labelerTableData = await getLabelerList({
      searchType: 'labeler',
    });
    setlabelerTableData(labelerTableData);
  };

  React.useEffect(() => {
    if (searchType !== 'Labeler') {
      getLabelerData();
    }
  }, []);
  
  //remove no data error msg 
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [planType, rebateProgram, spinnerLoader, fullScreenView, searchType, labelerFullScreen, ndcLeftFullScreen, ndcRightFullScreen]);

  // Handles the validation and if all is fine navigate to isplay screend
  const handleSearchClick = async (data, bypass = false) => {
    const errors = [];
    if (rebateProgram === '-1') {
      errors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }

    setErrorList(errors);
    // Sets store value using this action dispatch
    // data.sort((a, b) => a.drugSeqNum - b.drugSeqNum);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        selectedPlanType: radioList.find((item) => item.value === planType)
          ?.shortDesc,
        rebateProgram,
        plan: planType,
        rebateProgrameName,
        errors: errors,
        selectedSearchType: searchType,
        labelerTableData,
        selectedNDC: data,
        ndcLeftTableData,
        labelerSelectedRow,
        displayObj: {
          selectedNDC: data,
          rebateProgram,
          rebateProgrameName,
          labelerTableData,
          rebateProgramList: rebateProgramListData,
        },
      })
    );

    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (rebateProgram === '-1' || data.length === 0) {
      if (rebateProgram === '-1') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return;
    }
    if (rebateProgram != '-1') {
      setSelectedData(data);
      if (!bypass) {
        if (data.length > 1000) {
          setOpenModal(true);
          return;
        }
      }
      setSelectedData([]);
      let res = await dispatch(
        getndcdetailsgrid({
          drugSeqNum: data
            .filter((o, i) => i < 1000)
            .map((obj) => obj.drugSeqNum),
          rebateProgramCd: rebateProgram,
        })
      );
      // if (data.length === 1) {
      //   setIsSearchClicked(true);

      //   dispatch(
      //     getndcdetailsgrid({
      //       drugSeqNum: [data[0]?.drugSeqNum],
      //       rebateProgramCd: rebateProgram,
      //     })
      //   );
      // } else {
      // sets the name for the dispaly screen
      if (res?.length) {
        const grpData = Object.groupBy(res, ({ drugSeqNum }) => drugSeqNum);
        const availCodes = Object.keys(grpData);
        const filtered = data
          .filter(
            (obj) => availCodes.indexOf(obj?.drugSeqNum?.toString()) !== -1
          )
          .sort((o, i) => (o.ndc > i.ndc ? 1 : -1));
        dispatch(setNDCDetailReportData(filtered));
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/ndcdetailsdisplay',

          value: 'Display NDC Details',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        props.history.push({
          pathname: '/ndcdetailsdisplay',
        });
        dispatch(clearReduxForFilterAndSort('/ndcdetailsdisplay'));
      }
      // }
    }
  };

  if (isSearchClicked && searchResult.length > 0) {
    setIsSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/ndcdetailsdisplay',

      value: 'Display NDC Details',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/ndcdetailsdisplay',
    });
    dispatch(clearReduxForFilterAndSort('/ndcdetailsdisplay'));
  }
  // hanlde onclick on of yes from confirmation modal
  const handleYes = () => {
    handleSearchClick(selectedData, true);
  };
  return (
    <div className="tabs-container">
      <CustomSeparator parent1="Detail Reports" parent2="NDC Details" />
      <Spinner load={spinnerLoader} />
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="dialog-420"
        data-testid="common-modal-display"
        onOk={() => {
          setOpenModal(false);
          handleYes();
        }}
        okTitle="Yes"
        onClose={() => {
          setOpenModal(false);
          setSelectedData([]);
        }}
        closeTitle="No"
        modalTitle="Confirmation Dialog"
        childrenComponent={<div className="p-3">{NDC_LIMIT_TO_1000}</div>}
      />
      <DisplayErrorMessages errorMessages={errorList.map((l) => l.message)} />
      <div className="tab-body custom-search-dates">
        {!labelerFullScreen && !ndcLeftFullScreen && !ndcRightFullScreen && (
          <>
            <div className="row mb-3">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="ndc-detail-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'noData'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <Fieldset label="Rebate Program" required>
                  <SelectBoxComponent
                    data-testid="ndc-detail-rbt"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectedOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </Fieldset>
              </div>
            </div>
          </>
        )}
        <div className="row">
          <div className="col-sm-12">
            <SearchTypeComponent
              id="reportsNDC"
              data-testid="ndc-details-search-btn"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={handleSearchClick}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
              iconName="search"
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: 30 }}>
          {/* <div className="btn-wrapper col-12">
            <Button
              onClick={() => handleSearchClick()}
              className="btn btn-success btn-search float-right"
            >
              <SVGComponent iconName="Icon-search" /> Search
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
}
